import { parse, stringify } from 'hub-http/helpers/params';
import PortalIdParser from 'PortalIdParser';
export const getAccountVerificationUrl = () => {
  return `/account-verification/${PortalIdParser.get()}?source=FILE_MANAGER`;
};
export const stringifyQueryObject = queryObject => `?${stringify(queryObject)}`;
export const parseSearchString = search => parse(search.substring(1));